module.exports = __webpack_public_path__ + "post-listing-block-2-image@2x-1RptfQ8.jpg";